module.exports = __webpack_public_path__ + "img/new_index_customers7.e13f73db.png";